import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { createReportVersionDeliverableFileRoute, reportVersionDeliverableFilesRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { CreateReportDeliverableFileForm } from "app/component/report-deliverable-file/CreateReportDeliverableFileForm.tsx";

export const CreateReportVersionDeliverableFileScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(createReportVersionDeliverableFileRoute);
    const [created, setCreated] = useState(false);

    return created ? (
        <Navigate to={reportVersionDeliverableFilesRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={createReportVersionDeliverableFileRoute} />
                <CreateReportDeliverableFileForm
                    reportId={reportId}
                    versionId={versionId}
                    onCreate={() => setCreated(true)}
                />
            </Container>
        </NavigationScreen>
    );
};
